import React from "react";
import SearchBoard from "./SearchBoard";

const BoardSearch = ({ onSearch, searchQuery }) => {
  return (
    <div onKeyDown={(e) => e.stopPropagation()}>
      <SearchBoard onSearch={onSearch} searchQuery={searchQuery} />
    </div>
  );
};

export default BoardSearch;